import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IRegion } from '../../types/region';

export enum ERegionActionTypes {
  SetCurrentRegion = 'REGION/SET_CURRENT_REGION',
}

export type TSetCurrentRegion = ITypedReduxAction<ERegionActionTypes.SetCurrentRegion, IRegion>;

/**
 * Redux action, который задает выбранный регион
 * @param currentRegion IRegion
 */
export const setCurrentRegion: (currentRegion: IRegion) => TSetCurrentRegion = actionGenerator<
  ERegionActionTypes.SetCurrentRegion,
  IRegion
>(ERegionActionTypes.SetCurrentRegion);

export type TRegionActions = TSetCurrentRegion;
